var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 960 960",
    style: {
      enableBackground: "new 0 0 960 960"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4DA40;}\n\t.st1{fill:#FFED6C;}\n\t.st2{fill:#A67C52;}\n\t.st3{fill:#754C24;}\n\t.st4{fill:#FBB03B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.1,420.2c-68.1,0.9-124.2-49.8-125-113c-0.8-63.1,53.9-115.2,122-116.1s124.2,49.8,125,113 C474.9,367.3,420.2,419.4,352.1,420.2z M350.6,216.1c-55.1,0-99.9,40.2-99.9,89.6s44.8,89.6,99.9,89.6s99.9-40.2,99.9-89.6 S405.7,216.1,350.6,216.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M610.9,420.2c-68.1,0.9-124.2-49.8-125-113S539.8,191.9,608,191.1c68.1-0.9,124.2,49.8,125,113 C733.7,367.3,679,419.4,610.9,420.2z M609.4,216.1c-55.1,0-99.9,40.2-99.9,89.6s44.8,89.6,99.9,89.6s99.9-40.2,99.9-89.6 C709.3,256.3,664.5,216.1,609.4,216.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M572.9,658.4h-189l34.3-46.7c21.1-28.8,32.5-63.5,32.5-99.2v-36.1H506l0.1,36.4c0.1,35.5,11.4,70,32.3,98.6 L572.9,658.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M664.7,166H478.5H292.1c0,0-5,76.3,15.7,146.3c28.2,94.8,118.5,183.2,170.6,183.3l-0.1,0.4h0.7v0.8l0,0 c50-0.2,142.1-89.7,170.3-184.5C670,242.3,664.7,166,664.7,166z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.2,
    y: 658.4,
    className: "st2",
    width: 298.4,
    height: 128.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.6,
    y: 683.7,
    className: "st1",
    width: 231.7,
    height: 77.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M645.4,817.7h-334v-20.1c0-6,4.8-10.8,10.8-10.8h312.3c6,0,10.8,4.8,10.8,10.8v20.1H645.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M572.9,658.4h-189V642c0-6.4,5.2-11.5,11.5-11.5h165.9c6.4,0,11.5,5.2,11.5,11.5v16.4H572.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 384.4,
    cy: 702.1,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 575.2,
    cy: 702.1,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 384.4,
    cy: 742.9,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 575.2,
    cy: 742.9,
    r: 8.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M666.9,166.9H289.4c-6.8,0-12.3-5.5-12.3-12.3l0,0c0-6.8,5.5-12.3,12.3-12.3h377.4c6.8,0,12.3,5.5,12.3,12.3 l0,0C679.1,161.4,673.6,166.9,666.9,166.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "478.1,223.5 498.6,286.5 565,286.5 511.3,325.5 531.8,388.6 478.1,349.6 424.5,388.6 445,325.5  391.3,286.5 457.7,286.5  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/Trophy.853a5c5ec4dff7656981c9937d94ecda.svg";
export { ForwardRef as ReactComponent };